import {
  formatNumberWithComma,
  formatNumberWithCommaAndDollar,
  formatWithPercentage,
} from "@src/constants";

export const PROPERTY_TYPE = {
  ALL: 0,
  QUICK_SERVICE: 1,
  PINNACLE: 6,
  RESTAURANTS_CATERING: 2,
  QUICK_SERVICE_STORE: 5,
  QUICK_SERVICE_REVENUE_CENTERS: 3,
  RESTAURANTS_CATERING_REVENUE_CENTERS: 4,
};

export const PROPERTY = {
  MLSE: "000",
  SCOTIABANK_ARENA: "001",
  RESTAURANTS_CATERING: "002",
  BMO: "003",
  COCA_COLA_COLISEUM: "004",
  PINNACLE: "005",
};

interface geStilePercaptListDataTypes {
  mapData: {
    net: number | null;
    gross: number | null;
    sold_pct?: number | null;
    plan?: number | null;
  };
  isPerCap: boolean;
  hideGross: boolean;
}

// mapping data for stile
export const geStilePercaptListData = (props: geStilePercaptListDataTypes) => {
  const { mapData, isPerCap, hideGross } = props;

  const title = isPerCap ? "Plan" : "% of Plan";
  const value = isPerCap
    ? mapData?.plan && formatNumberWithCommaAndDollar(mapData?.plan)
    : mapData?.sold_pct && formatWithPercentage(mapData?.sold_pct);

  const Net = {
    title: "Net",
    value: isPerCap
      ? mapData?.net && formatNumberWithCommaAndDollar(mapData?.net)
      : mapData?.net && formatNumberWithComma(mapData?.net),
  };

  const PlanSold = {
    title,
    value,
  };

  const Gross = {
    title: "Gross",
    value: isPerCap
      ? mapData?.gross && formatNumberWithCommaAndDollar(mapData?.gross)
      : mapData?.gross && formatNumberWithComma(mapData?.gross),
  };

  return hideGross ? [Net, PlanSold] : [Net, Gross, PlanSold];
};

export const getMappedDashboardData = (props: {
  mapData: dashboardDataTypes;
}) => {
  const { mapData } = props;

  return {
    ...mapData,
    listGrossMargin: [
      {
        title: "%",
        value:
          mapData?.grossMargin?.pct &&
          formatWithPercentage(mapData?.grossMargin?.pct),
      },
      {
        title: "$",
        value:
          mapData?.grossMargin?.act &&
          formatNumberWithCommaAndDollar(mapData?.grossMargin?.act),
      },
    ],
    listGuestCount: [
      {
        title: "Total",
        value:
          mapData?.guest?.count && formatNumberWithComma(mapData?.guest?.count),
      },
      {
        title: "Avg $ / Guest",
        value:
          mapData?.guest?.avg &&
          formatNumberWithCommaAndDollar(mapData?.guest?.avg),
      },
    ],
    listTransactions: [
      {
        title: "Total",
        value:
          mapData?.transaction?.total &&
          formatNumberWithComma(mapData?.transaction?.total),
      },
      {
        title: "Avg $/Tr",
        value:
          mapData?.transaction?.avg &&
          formatNumberWithCommaAndDollar(mapData?.transaction?.avg),
      },
    ],
  };
};

export const initialDashboardData: dashboardDataTypes = {
  event_name: "",
  propertyType: 0,
  revenue_pct: null,
  currentSales: null,
  targetSales: null,
  last_updated: "",
  stile: {
    net: null,
    gross: null,
    sold_pct: null,
  },
  perCap: {
    net: null,
    gross: null,
    plan: null,
  },
  transaction: {
    total: null,
    avg: null,
  },
  grossMargin: {
    pct: null,
    act: null,
  },
  labour: {
    total_act: null,
    total_pct: null,
    target_act: null,
    target_pct: null,
  },
  cogs: {
    total_act: null,
    total_pct: null,
    target_act: null,
    target_pct: null,
  },
  guest: {
    count: null,
    avg: null,
  },
  compression: null,
  // added for api mapping data
  listTransactions: [],
  listGuestCount: [],
  listGrossMargin: [],
};
